import { render, staticRenderFns } from "./productModal.vue?vue&type=template&id=530554b4&scoped=true&"
import script from "./productModal.vue?vue&type=script&lang=tsx&"
export * from "./productModal.vue?vue&type=script&lang=tsx&"
import style0 from "./productModal.vue?vue&type=style&index=0&id=530554b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530554b4",
  null
  
)

export default component.exports